import { RosteredShift } from 'type';

export const getHasRosteredShiftsWithEvents = (rosterData: RosteredShift[]): boolean =>
  rosterData.some((rosteredShift: RosteredShift) => !!rosteredShift.event_id);
